<template>
	<div class="main" v-loading="list_loading">
		<div class="searchConent">
			<el-row>
				<el-col :span="3">姓名：</el-col>
				<el-col :span="9"><el-input v-model="name" placeholder="请输入"></el-input></el-col>
				<el-col :span="3">身份证号：</el-col>
				<el-col :span="9"><el-input v-model="idcardno" placeholder="请输入"></el-input></el-col>
			</el-row>
			<el-row>
				<el-col :span="3">联系方式：</el-col>
				<el-col :span="9"><el-input v-model="mobile" placeholder="请输入"></el-input></el-col>
			</el-row>
			<p class="search"><el-button @click="searchClick" type="primary" icon="el-icon-search">查询</el-button></p>
		</div>
		<el-row class="add-btn"><el-button type="primary" style="margin-right:40px;" @click="add_service = true">添加</el-button></el-row>
		<el-table :data="serviceList" border style="width: 100%">
			<el-table-column prop="id" label="id"></el-table-column>
			<el-table-column prop="name" label="姓名"></el-table-column>
			<el-table-column prop="mobile" label="联系方式"></el-table-column>
			<el-table-column prop="idcardno" label="身份证号"></el-table-column>
			<el-table-column label="操作">
				<template slot-scope="scope">
					<el-button size="mini" type="warning" @click="handleEdit(scope.row)" icon="el-icon-edit">编辑</el-button>
					<el-button size="mini" type="danger" @click="handleDelete(scope.row)" icon="el-icon-delete">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="block">
			<el-pagination
				@current-change="handleCurrentChange"
				:current-page="currentPage"
				background
				@size-change="handleSizeChange"
				:page-sizes="[5, 10, 20]"
				:page-size="pageSize"
				layout="sizes,prev, pager, next,total,jumper"
				:total="total"
			></el-pagination>
		</div>
		<!-- 添加服务人员列表 -->
		<el-dialog title="添加服务人员" :visible.sync="add_service" width="30%" @close="clearAddModel">
			<add-service ref="addserviceForm"></add-service>
			<span slot="footer" class="dialog-footer">
				<el-button @click="add_service = false">取 消</el-button>
				<el-button type="primary" @click="addUser1">确 定</el-button>
			</span>
		</el-dialog>
		<!-- 编辑平台列表 -->
		<el-dialog title="编辑服务人员" :visible.sync="edit_service" width="30%">
			<edit-service ref="editserviceForm"></edit-service>
			<span slot="footer" class="dialog-footer">
				<el-button @click="edit_service = false">取 消</el-button>
				<el-button type="primary" @click="addUser">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import addService from './service/add_service.vue';
import editService from './service/edit_service.vue';
export default {
	components: {
		addService,
		editService,
	},
	data() {
		return {
			total: 0, //总页数
			pageSize: 10, //每页条数
			currentPage: 1, //当前页（默认第一页）
			serviceList: [],
			name: '',
			idcardno: '',
			mobile: '',
			detail_dv: false,
			detail_loading: false,
			dialogUserInfo: [],
			handle: false,
			action: '',
			list_loading: false,
			add_service: false,
			edit_service: false
		};
	},
	created() {
		this.getServiceList();
	},
	mounted() {
		//判断子组件传的数（弹框关闭）
		
	},
	methods: {
		handleCurrentChange(val) {
			this.currentPage = val; //获取当前页
			this.getServiceList();
		},
		handleSizeChange(psize) {
			//选择每页条数
			this.pageSize = psize;
			this.getServiceList();
		},
		// 查询
		searchClick() {
			this.getServiceList();
		},
		//获取列表
		getServiceList() {
			let data=new FormData()
			data.append('length', this.pageSize);
			data.append('start', (this.currentPage - 1) * this.pageSize);
			data.append('name', this.name);
			data.append('idcardno', this.idcardno);
			data.append('mobile', this.mobile);
			
			this.$post('api/user/fuwu/list', data)
				.then(res => {
					window.console.log(111);
					window.console.log(res);
					this.serviceList = res.data.data;
					this.total = res.data.recordsFiltered;
					this.list_loading = false;
					this.serviceList.map(val=>{
						if(val.idcardno){
							val.idcardno=val.idcardno.substr(0,6)+"********"+val.idcardno.substr((val.idcardno.length-4),4)
						}
						if(val.mobile){
							val.mobile=val.mobile.substr(0,4)+"*****"+val.mobile.substr((val.mobile.length-2),2)													
						}
					})
					
				})
				.catch(e => {
					window.console.log(e);
				});
		},
		//添加服务人员
		addUser1() {
			this.$refs.addserviceForm.$refs.frmAdd.validate(valid => {
				if (valid) {
					let data = new FormData();
					data.append('name', this.$refs.addserviceForm.form.name);
					data.append('idcardno', this.$refs.addserviceForm.form.idcardno);
					data.append('mobile', this.$refs.addserviceForm.form.mobile);

					this.$post('api/user/fuwu/add', data)
						.then(res => {
							window.console.log(res);
							this.add_service = false;
							if (res.success == 1) {
								this.$message({
									message: res.message,
									type: 'success'
								});
								this.getServiceList();
							} else {
								this.$message({
									message: res.message,
									type: 'error'
								});
							}
						})
						.catch(e => {
							window.console.log(e);
						});
				} else {
					return this.$message({
						message: '请完整填写信息！',
						type: 'warn'
					});
				}
			});
		},
		clearAddModel() {
			//返回时清空表单数据
			this.$refs.addserviceForm.form = {
				name: '',
				idcardno: '',
				mobile: ''
			};
		},
		//编辑
		handleEdit(row) {
			this.edit_service = true;
			window.console.log(row);
			this.$nextTick(() => {
				//不用走接口获取table里的内容
				this.$refs.editserviceForm.form = Object.assign({}, row);
			});
		},
		//编辑确定
		addUser() {
			this.$refs.editserviceForm.$refs.frmAdd.validate(valid => {
				if (valid) {
					window.console.log(valid)
					
					let data = new FormData();
					data.append('name', this.$refs.editserviceForm.form.name);
					data.append('id', this.$refs.editserviceForm.form.id);
					
					this.$post('api/user/fuwu/update', data)
						.then(res => {
							window.console.log(res);
							if (res.success == 1) {
								this.$message({
									message: res.message,
									type: 'success'
								});
								this.getServiceList()
							} else {
								this.$message({
									message: res.message,
									type: 'error'
								});
							}
							this.edit_service = false
						})
						.catch(e => {
							window.console.log(e);
						});
				} else {
					return this.$message({
						message: '请完整填写信息！',
						type: 'warn'
					});
				}
			});
		},
		//删除
		handleDelete(row) {
			let data = new FormData();
			data.append('id', row.id);

			this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$post('api/user/fuwu/delete', data)
					.then(res => {
						let totalPage = Math.ceil((this.total - 1) / this.pageSize)
						let currentPage = this.currentPage > totalPage ? totalPage : this.currentPage
						this.currentPage = currentPage < 1 ? 1 : currentPage
						window.console.log(res);
						if (res.success == 1) {
							this.$message({
								type: 'success',
								message: res.message
							});
							this.getServiceList();
						}else{
							this.$message({
								type: 'error',
								message: res.message
							});
						}
					})
					.catch(e => {
						window.console.log(e);
					});
			});
		},
		
	}
};
</script>

<style scoped="scoped">
.main .block {
	text-align: center;
	margin-top: 20px;
}

.main {
	background: #fff;
	padding: 0 20px 20px 20px;
}
.add-btn {
	margin-bottom: 20px;
}

.add-btn .el-button {
	font-size: 16px;
}
.searchConent {
	padding-top: 20px;
}
.searchConent .el-row .el-col:first-of-type {
	border-right: 1px solid #eee;
}
.searchConent .el-row:first-of-type {
	display: flex;
	border: 1px solid #eee;
}
.searchConent .el-row:nth-of-type(2) {
	border-left: 1px solid #eee;
	border-bottom: 1px solid #eee;
	border-right: 1px solid #eee;
}
.searchConent .el-col:nth-of-type(3) {
	border-left: 1px solid #eee;
	border-right: 1px solid #eee;
}
.searchConent .el-col {
	height: 50px;
	padding: 5px;
	line-height: 38px !important;
	color: #606266;
	font-size: 14px;
}
.searchConent .el-col:first-of-type,
.searchConent .el-col:nth-of-type(3) {
	text-align: center;
}
.searchConent {
	margin-bottom: 20px;
}
.searchConent .search {
	text-align: right;
	margin-top: 20px;
}

/* .el-table td,
.el-table th {
	text-align: center;
} */
.searchConent .el-select {
	width: 100%;
}
</style>
